<template>
  <div class="form-field">
    <label class="form-field__label" :for="inputId">
      <slot name="label">{{ label }}</slot>
      <span
        v-if="helper"
        class="form-field__label-helper"
        :data-tooltip="helper"
        aria-label="Informații suplimentare"
      >?</span>
    </label>

    <select
      v-if="type === 'select'"
      :id="inputId"
      class="form-field__input"
      :class="{ 'form-field__input--error': firstError }"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option v-for="opt in options" :key="opt.value" :value="opt.value">
        {{ opt.label }}
      </option>
    </select>

    <textarea
      v-else-if="type === 'textarea'"
      :id="inputId"
      class="form-field__input"
      :class="{ 'form-field__input--error': firstError }"
      :value="modelValue"
      :placeholder="placeholder"
      rows="4"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>

    <input
      v-else
      :id="inputId"
      :type="type"
      class="form-field__input"
      :class="{ 'form-field__input--error': firstError }"
      :value="modelValue"
      :placeholder="placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
    />

    <slot name="below-input" />

    <span
      v-if="feedbackMessage"
      class="form-field__feedback"
      :class="`form-field__feedback--${feedbackType}`"
      v-html="feedbackMessage"
    />

    <span class="form-field__error" :class="{ 'form-field__error--visible': firstError }" aria-live="polite">
      {{ firstError }}&nbsp;
    </span>
  </div>
</template>

<script>
export default {
  name: "FormField",

  inject: {
    __livRegister: { default: null },
  },

  props: {
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    /*
     * Erori per câmp returnate de Laravel:
     * { username: ['Username-ul este deja folosit.'], ... }
     * Se pasează direct array-ul câmpului: :errors="validationErrors.username"
     */
    errors: {
      type: Array,
      default: () => [],
    },
    /*
     * Opțiuni pentru type="select": [{ value, label }]
     */
    options: {
      type: Array,
      default: () => [],
    },
    /*
     * Text explicativ afișat ca tooltip după label (iconița ?).
     */
    helper: {
      type: String,
      default: '',
    },
  },
  emits: ["update:modelValue"],

  data() {
    return {
      feedbackType: null,
      feedbackMessage: '',
    };
  },

  mounted() {
    this.__livRegister?.(this);
  },

  methods: {
    feedback(type, htmlMessage) {
      this.feedbackType = type;
      this.feedbackMessage = htmlMessage;
    },
  },

  computed: {
    inputId() {
      return "field-" + this.label.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    },
    firstError() {
      return this.errors && this.errors.length > 0 ? this.errors[0] : null;
    },
  },
};
</script>
